import { Cart } from './cart';

export class Customer {
  Id = '';
  Active: true;
  Deleted: true;
  Cart = new Cart();
  Version: string;
}
